/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import Loading from 'app/components/common/Loading.jsx';
import Modal from 'app/components/common/Modal.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';

class ReconnectSocialModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reconnectClicked: false
        };

        this.reconnect = this.reconnect.bind(this);
    }

    reconnect(socialNotice, e) {
        let serviceId = socialNotice.entityTypeId,
            paId = socialNotice.entityId,
			url = "/remote/beginreauth?psID=:psId&paID=:paId&state=:state&final=:final",
			date = new Date(),
			state = ['REAUTH', serviceId, paId, date.getTime(), socialNotice.hash].join("_"),
			constants = this.props.app.config.constants,
            returnUrl = window.location.href;

        if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
            if (parseInt(serviceId) === constants.POST_SVC_TWITTER) {
                this.props.closeAllModals();
                this.props.addModal(
                    <ConfirmModal
        				modalCopy="Twitter is currently unavailable. We're working to resolve this issue."
        				cancelAction={() => {
        					this.props.closeAllModals();
        				}}
        				showCancel={false}
        				confirmAction={() => {
        					this.props.closeAllModals();
        				}}
        				confirmLabel={"OK"}/>
                );
                this.props.clearNotices({
        			hash: socialNotice.hash
        		});
            }
        }

        if (parseInt(serviceId) === constants.POST_SVC_BLUESKY) {
            // turn off the reconnect modal
            let social = this.props.socials.list.find(({id}) => { return id === parseInt(paId); });
            if (social) {
                this.props.setModal();
                let blueskyModal = (
                    <SocialModal
                        {...this.props}
                        paId={paId}
                        handle={social.name}
                        activeTab="blueskycreds"
                        context="reconnect"
                    />
                );
                this.props.addModal(blueskyModal);
            }
            return;
        }

        // if the user is on a page that doesn't have a social listener, return them to
        // a page that does
        if (!returnUrl.match(/config\/socials/)) {
            returnUrl = this.props.app.config.appUrl + "/config/socials";
        }

        e.preventDefault();
        e.stopPropagation();

        if (this.state.reconnectClicked) {
            return;
        }

        // debounce clicks
        this.setState({
            reconnectClicked: true
        }, () => {
            url = url.replace(':psId', serviceId);
    		url = url.replace(':paId', paId);
    		url = url.replace(':state', state);
    		url = url.replace(':final', window.encodeURIComponent(returnUrl));
    		window.location.assign(url);
        });

    }

    render() {
        let headerContent = "Reconnect your Socials",
            menuContent = null,
            content = null,
            footerContent = null;

        if (this.props.socialNotices.length) {
            content = (
                <div className="social-notification-wrapper">
                    <ul className="social-notification-list">
                        {this.props.socialNotices.map(function(socialNotice, i) {
                            let social = this.props.findSocial(socialNotice.entityId),
                                element = null,
                                message = socialNotice.message,
                                constants = this.props.app.config.constants;

                            if (social !== undefined && social !== null) {
                                element = (
                                    <li key={i} className="social-notification-item">
                                        <div className="avatar-element">
                                            <SocialAvatar
                                                social={social}
                                                wrapperClass="standalone-avatar-wrapper"
                                                type="standalone"
                                                large={true}/>
                                        </div>
                                        <div className="social-info">
                                            <div className="social-name">
                                                {socialNotice.entityName}
                                            </div>
                                            <div className="social-notice">
                                                {message}
                                            </div>
                                        </div>
                                        <div className="social-reconnect">
                                            <button className="btn-flat social-reconnect" onClick={this.reconnect.bind(this, socialNotice)}>
                                                Reconnect
                                            </button>
                                        </div>
                                    </li>
                                );

                            }

                            return element;

                        }.bind(this))}
                    </ul>
                </div>
            );
        } else {
            content = <Loading />;
        }

        return (
            <Modal
                close={this.props.setModal}
                headerContent={headerContent}
                menuContent={menuContent}
                content={content}
                footerContent={footerContent}
                contentClass="reconnect-modal modal-content-padding"/>
        );
    }

};

ReconnectSocialModal.displayName = "ReconnectSocialModal";

ReconnectSocialModal.propTypes = {
    setModal: PropTypes.func,
    socialNotices: PropTypes.array
};

ReconnectSocialModal.defaultProps = {
    setModal: null,
    socialNotices: []
};

export default ReconnectSocialModal;
